<template>
	<div class='uploads'>
		<div class='uploads__title'>Материалы фотофиксации и треки</div>

		<div v-for='section in actLpoList' class='uploads__section-block'>
			<!-- <div class='uploads__header'>
				<span>{{ section.section + (section.section_lp ? ' (' + section.section_lp + ')' : '') }}</span>

				<div class='uploads__buttons'>
					<p-button label='Загрузить фото' class='p-button-sm p-mr-2'/>
					<p-button label='Загрузить треки' class='p-button-sm p-mr-2'/>
					<p-button label='Загрузить ТО' class='p-button-sm'/>
				</div>
			</div>

			<div class='uploads__content'>
				<ActUploadsPhoto :current-lpo='section' class='uploads__file-block'/>
				<ActUploadsTrack :current-lpo='section' class='uploads__file-block'/>
				<ActUploadsTax :current-lpo='section' class='uploads__file-block'/>
			</div> -->

			<ActUploadsSection :current-lpo='section'/>
		</div>

	</div>
</template>

<script>
	import { mapState } from 'vuex';

	import ActUploadsPhoto from './ActUploads__photo';
	import ActUploadsTrack from './ActUploads__track';
	import ActUploadsTax from './ActUploads__tax';

	import ActUploadsSection from './ActUploads__section';

	export default {
		name: 'ActUploads',

		components: {
			ActUploadsPhoto,
			ActUploadsTrack,
			ActUploadsTax,
			ActUploadsSection
		},

		computed: {
			...mapState('lpoData', {
				actLpoList: state => state.actLpoList
			})
		}

	};
</script>

<style lang='scss' scoped>
	// $content-padding: 15rem;

	.uploads__title {
		font-size: 1.2rem;
		font-weight: bold;
		color: #6c757d;
		margin-bottom: 2rem;
	}

	.uploads__header {
		margin-bottom: 1.2rem;
	}

	.uploads__buttons,
	.uploads__content {
		// padding: 0 $content-padding;
	}

	.uploads__section-block {
		margin-bottom: 4rem;
	}

	.uploads__file-block {
		margin-bottom: 1.2rem;
	}
</style>